import { get, post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import EvaluationCategoryUpdateRequest from "../form/request/EvaluationCategoryUpdateRequest";

const API_PREFIX = "/evaluationCategory";

export const init = async () => {
  const response = await get(`${API_PREFIX}/`, authHeader());
  console.log("response", response);
  return response.data;
};

export const update = async params => {
  const response = await post(`${API_PREFIX}/update`, new EvaluationCategoryUpdateRequest(params), authHeader());
  console.log("response", response);
  return response.data;
};
